<div class="notification-action">
<div class="event-item">
  <span class="notification-activity date">{{notification.created | date:'dd MMM yyyy'}}</span>
  <div class="header-notification">
    <h3>Recording in progress</h3>
  </div>
  <p><span (click)="stop()" class="action-link">STOP</span> the recording now!</p>
</div>
</div>